import { postApi } from "./api_instance";

export const addWishlist = async (info, dispatch) => {
  try {
    const data  = await postApi({
      apiUrl: "/projects/api/my-wishlist/create",
      sendToken: true,
      dispatch,
      data: info,
    });
    return data;
  } catch (error) {
    throw error;
  }
};